<script lang="ts">
	import {
		type NewsletterProvenance,
		NewsletterStartTrigger,
	} from '../../constants/mixpanel-events';
	import { NewsletterForm } from '../NewsletterForm';
	import type { DialogStores } from '$global/components/Dialog';
	import { Dialog } from '$global/components/Dialog';
	import { Txt } from '$global/components/Txt';

	interface Props {
		dialogStores: DialogStores;
		dataCy: string;
		title: string;
		description: string;
		listId: number;
		provenance: NewsletterProvenance;
	}

	let { dialogStores, dataCy, title, description, listId, provenance }: Props =
		$props();

	const handleClose = () => {
		dialogStores.states.open.set(false);
	};

	let dataCyPrefix = $derived(`${dataCy}-newsletter`);
</script>

<Dialog
	{title}
	showOverlay
	{dialogStores}
	dataCy={dataCyPrefix}
	onClose={handleClose}
	class="h-auto max-w-[28rem] rounded p-[1.5rem] pt-[1rem] sm:p-[2rem] sm:pt-[1rem]"
	titleVariant="h4"
	classes={{
		title: 'mb-4 sm:mb-2 mt-4',
	}}
>
	<Txt variant="body2" class="pb-4 text-center">{description}</Txt>
	<NewsletterForm
		isHeniNewsletter={false}
		{listId}
		{provenance}
		startTrigger={NewsletterStartTrigger.Mount}
		fullWidthInput
		showSeparateFields
		captureName
		classes={{
			subscribeHelperText: 'text-center',
		}}
		inputPropsEmail={{
			label: 'Email Address',
			required: true,
		}}
	/>
</Dialog>
